function isDecimal(n) {
    return n && n.toString().match(/^[-+]?[0-9]+\.[0-9]+$/) ? true : false;
}
function convertToString(val) {
    if (val) {
        return val.toString().trim().toLowerCase()
    } else {
        return "";
    }
}
function rules(rule, disabled, data, formdata) {

    let ruleControl = Array.isArray(rule.control) ? rule.control[0] : rule.control;
    let ruleValue = rule.value;
    if (rule.isvaluefrommodel) {
        if (rule.modelfromformid) {
            let _data = formdata[rule.modelfromformid + 'write'] ? formdata[rule.modelfromformid + 'write'] : {};
            ruleValue = _data[rule.value]
        } else {
            ruleValue = data[rule.value]
        }
    }
    switch (rule.operator[0]) {
        case '=':
            disabled = convertToString(ruleValue) === convertToString(data[ruleControl]);
            break;
        case '<>':
            disabled = convertToString(ruleValue) !== convertToString(data[ruleControl]);
            break;
        case '>':
            disabled = parseFloat(ruleValue) < parseFloat(data[ruleControl]);
            break;
        case '<':
            disabled = parseFloat(ruleValue) > parseFloat(data[ruleControl]);
            break;
        case 'in':
            if (Array.isArray(data[ruleControl])) {
                disabled = data[ruleControl].indexOf(ruleValue) > -1;
            } else {
                disabled = convertToString(ruleValue).replace(/, /g, ",").split(",").indexOf(convertToString(data[ruleControl])) > -1;
            }
            break;
        case 'integer':
            disabled = !isDecimal(data[ruleControl]);
            break;
    }
    return disabled;
}
function ruleChecker(ActionRules, type, data, formdata) {
    var disabled = null;
    if (Array.isArray(ActionRules)) {
        var rulesOR = ActionRules.filter(x => x.action === type && (x.condition === 'or' || !x.condition));
        rulesOR.forEach(rule => {
            if (disabled === false || disabled === null) {
                disabled = rules(rule, disabled, data, formdata);
            }
        })

        var rulesAND = ActionRules.filter(x => x.action === type && x.condition === 'and');
        if (rulesAND.length > 0 && (disabled || rulesOR.length == 0)) {
            rulesAND.forEach(rule => {
                if (disabled !== false) {
                    disabled = rules(rule, disabled, data, formdata);
                }
            })
        }
    }
    return disabled == null ? false : disabled;
}
const actionType = (rulesParam) => {
    return Array.isArray(rulesParam) && rulesParam.length > 0 ? rulesParam[0].action : '';
}
const ruleCheck = (rulesParam, data, formdata) => {
    if (rulesParam && rulesParam.length > 0) {
        if (actionType(rulesParam) === 'hide') {
            return !ruleChecker(rulesParam, 'hide', data, formdata);
        } else if (actionType(rulesParam) === 'show') {
            return ruleChecker(rulesParam, 'show', data, formdata);
        } else if (actionType(rulesParam) === 'disable') {
            return !ruleChecker(rulesParam, 'disable', data, formdata);
        } else if (actionType(rulesParam) === 'enable') {
            return ruleChecker(rulesParam, 'enable', data, formdata);
        }
    }
    else {
        return true;
    }
}
export {
    actionType,
    ruleCheck
};